module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-25.f5b15e97.jpg";